import React from 'react';
import PropTypes from 'prop-types';

import Option from './Option';
import { ERROR_TYPES } from '../../../constants';

const ErrorTypesField = ({ value, onChange }) => (
  <div className="annotator-field">
    <span>Quality issue</span>
    <div className="annotator-button-list">
      {
        Object.keys(ERROR_TYPES).map(key => (
          <Option
            key={key}
            id={key}
            value={key}
            name="error-type"
            onChange={e => onChange(e.target.value)}
            defaultChecked={value === key ? 'checked' : null}
          >
            <span>{ERROR_TYPES[key]}</span>
          </Option>
        ))
      }
    </div>
  </div>
);

ErrorTypesField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ErrorTypesField.defaultProps = {
  value: '',
};

export default ErrorTypesField;
